
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.977 2.742h-.805a1.166 1.166 0 00-.25-.562.616.616 0 00-.5-.227c-.557 0-.925.453-1.102 1.36-.099.526-.172 1.455-.218 2.789.77.208 1.388.526 1.851.953.557.51.912 1.156 1.063 1.937l.726-1.39.555.289-1.203 2.351-.438.11-2.164-1.336.305-.54 1.375.766a3.177 3.177 0 00-.805-1.492c-.307-.313-.737-.555-1.289-.727-.01.74-.016 1.573-.016 2.5 0 1.25-.054 2.38-.164 3.391.584-.114 1.055-.36 1.415-.734a3.36 3.36 0 00.82-1.407l.922.282c-.22.708-.63 1.323-1.235 1.843a3.722 3.722 0 01-2.023.875c-.12.808-.279 1.524-.477 2.149-.49 1.578-1.356 2.367-2.601 2.367-.25 0-.469-.02-.657-.062a2.172 2.172 0 01-.546-.204l.101-1.539h.735c.067.25.166.456.296.618.136.161.326.242.57.242.548 0 .891-.568 1.032-1.703.063-.521.112-1.151.148-1.891-.593-.13-1.101-.346-1.523-.648-.443-.323-.807-.758-1.094-1.305A4.02 4.02 0 01.36 9.945c0-.656.133-1.252.399-1.789a3.747 3.747 0 011.14-1.367c.464-.354 1.055-.588 1.774-.703.13-1.135.315-2.068.555-2.797C4.742 1.742 5.633.97 6.898.97c.183 0 .383.026.602.078.224.047.414.107.57.18l-.093 1.515zm-6 5.219c-.438.552-.657 1.213-.657 1.984 0 .74.198 1.367.594 1.883.385.505.89.854 1.516 1.047.02-.656.03-1.385.03-2.188 0-1.39.043-2.624.126-3.703a2.713 2.713 0 00-1.61.977z","fill":"currentColor"}})])
          )
        }
      }
    